import { ReactNode, useRef, useState } from 'react'
import TouchableOpacity from '../TouchableOpacity'
import Text from '../Text'
import styles from './style'

interface ListRowProps {
  leading?: ReactNode
  label: ReactNode
  labelColor?: string
  // Full text shown on hover when the single-line label gets cut off.
  // Defaults to the label itself when it's a plain string.
  tooltip?: string
  onClick?: () => void
  actions?: ReactNode
  disabled?: boolean
}

function ListRow({
  leading,
  label,
  labelColor,
  tooltip,
  onClick,
  actions,
  disabled = false,
}: ListRowProps) {
  const [hovered, setHovered] = useState(false)
  const [truncated, setTruncated] = useState(false)
  const labelRef = useRef<HTMLDivElement>(null)

  const tooltipText = tooltip ?? (typeof label === 'string' ? label : undefined)

  return (
    <div
      onMouseEnter={() => {
        setHovered(true)
        const element = labelRef.current
        setTruncated(!!element && element.scrollWidth > element.clientWidth)
      }}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...styles.container,
        backgroundColor: hovered ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <TouchableOpacity
        disabled={disabled || !onClick}
        style={styles.inner}
        onClick={onClick}
      >
        {leading}
        <Text
          ref={labelRef}
          title={truncated ? tooltipText : undefined}
          style={{ ...styles.label, color: labelColor }}
        >
          {label}
        </Text>
      </TouchableOpacity>
      {actions ? <div style={styles.actionsWrapper}>{actions}</div> : null}
    </div>
  )
}

export default ListRow
